/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        // nav bar scroll effect
        var scroll_start = 0;
        var currentLogo = $('a.brand').html();
        var scrolledLogo = $('.scrolled-logo').html();

      if (window.location.href.indexOf("/login") > -1) {
          $("header.banner").addClass('scrolled');
          $('a.brand').html(scrolledLogo);
      } else {
        $(document).on('scroll', function() { 
          scroll_start = $(this).scrollTop();
          if(scroll_start > 100) {
            $("header.banner").addClass('scrolled');
            $('a.brand').html(scrolledLogo);
          } else {
            $('header.banner').removeClass('scrolled');
            $('a.brand').html(currentLogo);
          }
        });

        // mobile menu

        var icon = document.getElementById("icon");
        var icon1 = document.getElementById("a");
        var icon2 = document.getElementById("b");
        var icon3 = document.getElementById("c");
        
        var menu = $('.menu-primary-navigation-container');

        icon.addEventListener('click', function() {
          icon1.classList.toggle('a');
          icon2.classList.toggle('c');
          icon3.classList.toggle('b');
          $(menu).toggleClass('open');
        });

        // pricing page tabs
        $( "#tabs" ).tabs();

        // archive page - disable buy now btn if quantity is less than min val allowed
        $('input.qty').on('change', function() {
          $minQty = $(this).attr('min');
          $currVal = $(this).val();


          $(this).parent().parent().find($('.add_to_cart_button')).attr('data-quantity', $currVal);

          if($(this).val() < parseInt($minQty)) {

            $(this).parent().parent().find($('.add_to_cart_button')).css('display', 'none');
            $(this).parent().parent().find($('.add_to_cart_error')).css('display', 'block');
          } else {

            $(this).parent().parent().find($('.add_to_cart_button')).css('display', 'block');
            $(this).parent().parent().find($('.add_to_cart_error')).css('display', 'none');
          }

        });

        // on add to cart button click - update the data-quantity value to be the same as the quanitiy field if it exists
        $('.add_to_cart_button').on('click', function() {

          if($(this).parent().has($('.qty'))) {

            $quantityVal = $(this).parent().find('.qty').val();

            $(this).attr('data-quantity', $quantityVal);
          }

        });


        // checkout
        jQuery( document.body ).on( 'applied_coupon_in_checkout', function () {
          location.reload();
        } );


      }
        
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
        
        // open sub menus

        // if mobile 
        
        $('.menu-item-has-children > a').attr('href', '#');        
        if($( window ).width() < 768) {
          $('.menu-item-has-children').on('click', function() {  
            if ( $(this).find('.sub-menu').is( ":hidden" ) ) {
              $(this).find('.sub-menu').slideDown( "slow" );
              $(this).find('.sub-menu').toggleClass('reveal-items');
            } else {
              $( this ).find('.sub-menu').hide();
              $(this).find('.sub-menu').toggleClass('reveal-items');
            }
          });
        } else {
          // if desktop
  
          $('.menu-item-has-children').on( 'mouseenter', function() {
            //Show menu
            $(this).find('.sub-menu').css({'display' : 'block'});
            $(this).addClass('menu-open');
            
          }); 
          $('.sub-menu').on( 'mouseleave',function() {
            //Hide the menu
            setTimeout(function() {
              $('.sub-menu').css({'display' : 'none'});
            }, 500);

            $('.menu-item-has-children').removeClass('menu-open');
            
          });
        }


        // video modal
        var $videoSrc;  
        $('.type__video a').on('click', function() {
            $videoSrc = $(this).data( "src" );
        });
        console.log($videoSrc);

          
          
        // when the modal is opened autoplay it  
        $('#videoModal').on('shown.bs.modal', function (e) {
          $("#video").attr('src',$videoSrc); 
        });
          


        // stop playing the youtube video when I close the modal
        $('#videoModal').on('hide.bs.modal', function (e) {
            // a poor man's stop video
            $("#video").attr('src',$videoSrc); 
        }) ;
    


      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS


        // play youtube video when custom button is clicked

        $(".video-control__play").on('click', function(){
          $(".section__video iframe")[0].src += "&autoplay=1";
         });
      }
    },
    // About us page, note the change from about-us to about_us.
    'faq': {
      init: function() {
        
        $('.wp-block-uagb-faq-child').each(function(i) {
          $(this).attr('data-aos', 'fade-up');
          $(this).attr('data-aos-delay', i * 100);
        });
        AOS.refreshHard();

      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
